import { paramCase } from 'change-case';
import { useEffect, useRef } from 'react';

export const buildElementId = (name: string) => {
  return paramCase(name);
};

export const replaceAll = function (replaceThis: string, withThis: string, inThis: string) {
  if (withThis) {
    // eslint-disable-next-line no-param-reassign
    withThis = withThis.replace(/\$/g, '$$$$');
  }
  return inThis.replace(
    // eslint-disable-next-line no-useless-escape
    new RegExp(replaceThis.replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|<>\-\&])/g, '\\$&'), 'g'),
    withThis
  );
};

export const capitalize = (string) => string.charAt(0).toUpperCase() + string.slice(1);

export const getLastElementOfSplit = (str: string, separator: string) => {
  const pathArray = str.split(separator);
  return pathArray[pathArray.length - 1];
};

/** Performs comparing of two items by specified properties
 * @param  {Array} props for sorting ['name'], ['value', 'city'], ['-date']
 * to set descending order on object property just add '-' at the begining of property
 */
export const compareBy =
  (...props) =>
  (a, b) => {
    for (let i = 0; i < props.length; i++) {
      const ascValue = props[i].startsWith('-') ? -1 : 1;
      const prop = props[i].startsWith('-') ? props[i].substr(1) : props[i];
      if (a[prop] !== b[prop]) {
        return a[prop] > b[prop] ? ascValue : -ascValue;
      }
    }
    return 0;
  };

export const buildApiReferenceTableId = ({ definitionName }: { definitionName: string }) => {
  return `api-ref_${paramCase(definitionName)}`;
};

export const useOuterClick = (callback) => {
  const callbackRef = useRef(); // initialize mutable ref, which stores callback
  const innerRef = useRef(); // returned to client, who marks "border" element

  // update cb on each render, so second useEffect has access to current value
  useEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
    function handleClick(e) {
      // @ts-ignore
      if (innerRef.current && callbackRef.current && !innerRef.current.contains(e.target)) callbackRef.current(e);
    }
  }, []); // no dependencies -> stable click listener

  return innerRef; // convenience for client (doesn't need to init ref himself)
};
